import { useLayoutEffect } from 'react';
import { usePageConfig } from '../../../hooks/usePageConfig';
import { solutionsStore } from '../../../stores/solutionsStore';

/**
 * Syncs active solution from route pageConfig into solutionsStore.
 *
 * TODO: In the future, replace direct solutionsStore usage with a useActiveSolution hook
 * that reads solution directly from usePageConfig() — removing the need for this sync entirely.
 */
export const useSyncActiveSolutionFromRoute = () => {
  const { solution } = usePageConfig();
  useLayoutEffect(() => {
    solutionsStore.setActiveSolutionFromRoute(solution ?? null);
  }, [solution]);
};
